<template lang="pug">
modal#remove-organization-modal(
  :buttonColor='buttonColor'
  :close-button-label='$t("button.cancel")'
  :loading='loading'
  :process-button-label='$t("button.remove")'
  :title='$t("modal.removeOrganization.title")'
  @process='removeOrganization'
  ref='modal'
)
  p {{ $t('modal.removeOrganization.message1') }}
    |
    | {{ $t('modal.removeOrganization.message2') }}
  p {{ $t('modal.removeOrganization.message3') }}
  .form-control-icon
    icon(:fix-width='true' name='key')
    input#password.form-control(
      :placeholder='$t("modal.removeOrganization.passwordPlaceholder")'
      aria-describedby='emailHelp'
      type='password'
      v-model='password'
    )
    button.show-password(
      @click='showPassword'
      data-password-input-id='password'
      type='button'
    )
      icon(:fix-width='true' name='eye')
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import ImageLoader from '@/ui/molecules/ImageLoader.vue';
import Icon from '@/ui/atoms/Icon.vue';
import OrganizationsHttp from '@/services/OrganizationsHttp';

export default {
  name: 'RemoveOrganizationModal',
  props: {
    organizationId: [Number, String],
  },
  components: {
    Modal,
    Icon,
    ImageLoader,
    OrganizationsHttp,
  },
  data() {
    return {
      loading: false,
      buttonColor: true,
      errors: {},
      name: '',
      logo: '',
      organization: {},
      type: 'password',
      password: '',
    };
  },
  methods: {
    removeOrganization() {
      this.loading = true;
      OrganizationsHttp.deleteOrganization(this.organizationId, {
        password: this.password,
      })
        .then(() => {
          this.loading = false;
          this.$refs.modal.close();
          this.$emit('change-organization');
        })
        .catch(() => {
          this.loading = false;
        });
    },
    showPassword() {
      if (this.type === 'password') {
        this.type = 'text';
      } else {
        this.type = 'password';
      }
    },
  },
};
</script>
